<!--
 * @Date: 2021-07-18 08:50:45
 * @LastEditors: natsu
 * @LastEditTime: 2021-08-24 08:56:07
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>其他库存</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/groceries/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "license",
          linkList: [ur + "license.js"]
        },
        {
          label: "FileSaver",
          linkList: [ur + "FileSaver.js"]
        },
        {
          label: "gc.spread.excelio.10.1.0",
          linkList: [ur + "gc.spread.excelio.10.1.0.min.js"]
        },
        {
          label: "verify-gamma",
          linkList: [ur + "verify-gamma.js"]
        },
        {
          label: "XSS攻击解决方案",
          linkList: [ur + "xss.min.js"]
        },
        {
          label: "打印控件",
          linkList: [ur + "CLodop_Setup_for_Win64NT_3.048Extend.zip"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListGroceries.vue